import { client } from 'src/utils/client'
import { IUser } from 'src/store/models/user'
import config from 'src/config'

export const getUser = async (): Promise<IUser> =>
  await client(`${config.HOST_API}/users/me`)

export const checkUsername = async (
  queryParam: string
): Promise<{ usernameTaken: boolean }> =>
  await client(`${config.HOST_API}/users/username?username=${queryParam}`)

export const updateUser = async ({
  username,
  firstName,
  birthday,
  genderId,
  city,
  instagram,
  twitter,
  profilePicture,
}: Partial<{
  username: IUser['username']
  firstName: IUser['firstName']
  birthday: IUser['birthday']
  genderId: number
  city: IUser['city']
  instagram: IUser['instagram']
  twitter: IUser['twitter']
  profilePicture: IUser['profilePicture']
}>): Promise<IUser> =>
  await client(`${config.HOST_API}/users/me`, {
    method: 'PATCH',
    body: {
      username,
      firstName,
      birthday,
      genderId,
      city,
      instagram,
      twitter,
      profilePicture,
    },
  })

export const deleteUser = async () =>
  await client(`${config.HOST_API}/users/me`, { method: 'DELETE' })
